<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<app-generic-modal (primaryActionEvent)="save()"
  [primaryActionEnabled]="isValid"
  [primaryActionTitle]="primaryActionTitle"
  [title]="title"
  secondaryActionTitle="Discard">
  @if (!modelCodeArrayIsValid) {
    <div class="warning-box-wrapper">
      <app-warning-box [warningLevel]="WarningsEnum.ERROR">
        {{invalidActionText}}
      </app-warning-box>
    </div>
  }
  <div class="business-modal-body">
    <app-input-text #name
      (inputValueChange)="nameInputChange($event)"
      [messages]="nameInputMessages"
      [validators]="validators.name"
      [warningLevel]="WarningsEnum.WARNING_SAVE"
      baseCypressTag="business-settings-technician-group-modal-name"
      label="Technician group name"
      maxLength="20"
    placeholder="Please, write a technician group name"></app-input-text>
    <div>
      <app-tooltip
        [orderedList]="false"
        [tooltipType]="TooltipEnum.INFORMATION"
        class="display-inline-flex vertical-align-baseline"
        message="The model code expertise limits the technician group to answer PNCs containing only the chosen model codes in this field."
        placement="right">
        <p class="label" data-cy="business-settings-technician-group-modal-model-codes-label">Model codes
        expertise</p>
      </app-tooltip>
      <app-chip-input (chipsValues)="modelCodesInputChange($event)"
      [chipInputConfiguration]="modelCodesInputConfiguration"></app-chip-input>
    </div>

    <app-active-input (checkState)="setActiveInputState($event)" [entityName]="ENTITY_NAME"
    [state]="$safeNavigationMigration(state?.isActive)"></app-active-input>
  </div>
</app-generic-modal>
